/**
 * Target interval between queue-depth samples taken by the queue-depth-metrics worker.
 *
 * Shared with the dashboard, which compares it against the chart bucket width to decide
 * whether gaps between samples are expected (and should be drawn through) or real.
 */
export const QUEUE_DEPTH_SAMPLING_INTERVAL_SECONDS = 15;
